import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../icon.js';

function Security(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-labelledby": "security-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      children: [
        /* @__PURE__ */ jsx("title", { id: "security-icon", children: "A security icon" }),
        /* @__PURE__ */ jsx("path", { d: "M6.71429 21H5V6.42857C5 4.53502 6.53502 3 8.42857 3H15.2857C17.1793 3 18.7143 4.53502 18.7143 6.42857V21H17V6.42857C17 5.4818 16.2325 4.71429 15.2857 4.71429H8.42857C7.4818 4.71429 6.71429 5.4818 6.71429 6.42857V21Z" }),
        /* @__PURE__ */ jsx("path", { d: "M10.7964 8.98929C11.0893 9.28214 11.4429 9.42857 11.8571 9.42857C12.2714 9.42857 12.625 9.28214 12.9179 8.98929C13.2107 8.69643 13.3571 8.34286 13.3571 7.92857C13.3571 7.51429 13.2107 7.16071 12.9179 6.86786C12.625 6.575 12.2714 6.42857 11.8571 6.42857C11.4429 6.42857 11.0893 6.575 10.7964 6.86786C10.5036 7.16071 10.3571 7.51429 10.3571 7.92857C10.3571 8.34286 10.5036 8.69643 10.7964 8.98929Z" }),
        /* @__PURE__ */ jsx("path", { d: "M10.1429 15.8571V19.2857C10.1429 19.5286 10.225 19.7321 10.3893 19.8964C10.5536 20.0607 10.7571 20.1429 11 20.1429H12.7143C12.9571 20.1429 13.1607 20.0607 13.325 19.8964C13.4893 19.7321 13.5714 19.5286 13.5714 19.2857V15.8571C13.8143 15.8571 14.0179 15.775 14.1821 15.6107C14.3464 15.4464 14.4286 15.2429 14.4286 15V12C14.4286 11.5286 14.2607 11.125 13.925 10.7893C13.5893 10.4536 13.1857 10.2857 12.7143 10.2857H11C10.5286 10.2857 10.125 10.4536 9.78929 10.7893C9.45357 11.125 9.28571 11.5286 9.28571 12V15C9.28571 15.2429 9.36786 15.4464 9.53214 15.6107C9.69643 15.775 9.9 15.8571 10.1429 15.8571Z" })
      ]
    }
  ) });
}

export { Security as default };
